// Reusable segmented control for switching between view types on a collection
// (e.g. List/Board/Calendar/Table). Config-driven via `views` so any collection
// can offer whatever view types it supports.
import { Segmented } from '../ds/index.js'

export default function ViewSwitcher({ view, onSetView, views }) {
  return <Segmented value={view} onChange={onSetView} options={views} size="sm" />
}
